import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CalendarDays, Check } from "lucide-react";
import { apiAssetUrl, getMyCohorts } from "@/lib/api";

const day = (value) => new Date(`${value}T00:00:00`).toLocaleDateString(undefined, { day: "numeric", month: "short" });

// Dashboard strip: where the member stands in a cohort, or the next one they could join.
export default function CohortBanner({ hideNext = false }) {
  const [items, setItems] = useState(null);
  useEffect(() => {
    let active = true;
    getMyCohorts().then((result) => { if (active) setItems(result.items || []); }).catch(() => { if (active) setItems([]); });
    return () => { active = false; };
  }, []);
  if (!items) return null;

  const mine = items.find((item) => item.membership && ["open", "closed", "running"].includes(item.status));
  const request = items.find((item) => item.partnerRequest && !item.membership);
  // canJoin already accounts for the plan's partnership limit and the cohort's over-limit setting.
  const next = items.find((item) => item.canJoin && !item.membership && !item.partnerRequest);
  const cohort = mine || request || (!hideNext && next);
  if (!cohort) return null;
  const member = cohort.membership;
  const asked = !member && cohort.partnerRequest;

  return (
    <div className="hm-card mb-5 flex flex-wrap items-center gap-4 rounded-md border-[#F59E0B]/20 p-5" data-testid="dash-cohort">
      {cohort.imageUrl ? (
        <img src={apiAssetUrl(cohort.imageUrl)} alt="" className="h-14 w-11 shrink-0 rounded-sm border border-white/10 object-cover" />
      ) : (
        <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-sm border border-[#F59E0B]/30 text-[#F59E0B]">
          {member ? <Check className="h-4 w-4" strokeWidth={1.75} /> : <CalendarDays className="h-4 w-4" strokeWidth={1.5} />}
        </span>
      )}
      <div className="min-w-0 flex-1">
        <div className="overline mb-1">{member ? "Your cohort" : asked ? "Cohort request" : "Next cohort"}</div>
        <div className="text-sm text-[#F5F5F0]">
          {member?.status === "paired"
            ? `${cohort.name}: you're doing it with ${member.partner?.fullName || "your partner"}.`
            : member?.status === "awaiting_partner"
              ? `${cohort.name}: waiting for ${member.joinMode === "partner" ? member.partner?.fullName || "your partner" : "your friend"} to join you.`
              : member
                ? `${cohort.name}: you're in. We'll pair you by ${day(cohort.startsOn)}.`
                : asked
                  ? `${asked.fullName} wants to do ${cohort.name} with you.`
                  : `${cohort.name} starts ${day(cohort.startsOn)} · ${cohort.spotsLeft} spots left. Come alone, with your partner, or with a friend.`}
        </div>
      </div>
      {member?.status === "paired" && member.partnershipId ? (
        <Link to={`/workspace/${member.partnershipId}`} className="hm-btn-primary inline-flex items-center gap-2 rounded-md px-4 py-2 text-xs font-semibold">Open workspace <ArrowRight className="h-3.5 w-3.5" /></Link>
      ) : (
        <Link to={`/cohorts/${cohort.slug}`} className={`${member && !asked ? "hm-btn-ghost" : "hm-btn-primary font-semibold"} inline-flex items-center gap-2 rounded-md px-4 py-2 text-xs`}>{member ? "View cohort" : asked ? "Answer" : "Join cohort"} <ArrowRight className="h-3.5 w-3.5" /></Link>
      )}
    </div>
  );
}
